export const Constants = {
  oversight: 'Proto Oversight',
  oversight_title_tooltip:
    'Monitore sessões, acesso delegado e atividades suspeitas nas contas dos usuários',
};
